import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback, useRef, useState } from 'react';
export default /*#__PURE__*/React.memo(function (_ref2) {
  var children = _ref2.children;
  var ref = useRef(null);

  var _useState = useState(ref),
      _useState2 = _slicedToArray(_useState, 2),
      stateRef = _useState2[0],
      setStateRef = _useState2[1];

  var setRef = useCallback(function (_ref) {
    if (stateRef.current !== _ref) {
      setStateRef(_objectSpread(_objectSpread({}, ref), {}, {
        current: _ref
      }));
    }
  }, []);
  return children({
    ref: stateRef,
    setRef: setRef
  });
});